import React from "react";
import { createSvgIcon } from "@mui/material";

const rawIcon = ({ colorI, colorII, width, height }) => {
  return (
    <svg
      width={width ?? "24"}
      height={height ?? "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke={colorI}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8V12L15 15"
        stroke={colorII}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ScheduleIcon = ({ colorI, colorII, width, height }) => {
  const icon = rawIcon({ colorI, colorII, width, height });
  return createSvgIcon(icon);
};

export const MUIScheduleIcon = ScheduleIcon;
export default rawIcon;
